import React from "react";
import { BookStore, Dispatcher } from "../../flux";
import Chapters from "./chapters";
import Header from "./header";
import FiguresOverlay from "./overlay";
import FigureCardContainer from "./figure-card-container";
import PanelHeader from "./PanelHeader";

class FiguresContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      figures: [],
      selectedFigures: null,
      loadCard: 250,
      loadImage: 50,
      activeIndex: null,
      sortOrder: "az"
    };

    this._getFigures = this._getFigures.bind(this);
    this.selectFigures = this.selectFigures.bind(this);
    this._scrollFigures = this._scrollFigures.bind(this);
    this._loadMoreImages = this._loadMoreImages.bind(this);
    this._enlargeFigure = this._enlargeFigure.bind(this);
    this._goToNextFigure = this._goToNextFigure.bind(this);
    this._goToPreviousFigure = this._goToPreviousFigure.bind(this);
    this._closeFigure = this._closeFigure.bind(this);
    this.onSort = this.onSort.bind(this);
    this._backToChapters = this._backToChapters.bind(this);
    this._closeFiguresPanel = this._closeFiguresPanel.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.BOOK_FIGURES_LOADED, this._getFigures);
    this._getFigures(); // call this in case figures load when not mounted
  }

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.BOOK_FIGURES_LOADED, this._getFigures);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  _closeFiguresPanel() {
    Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "figures");
  }

  _getFigures() {
    const book = BookStore.get(this.props.isbn);
    const figures = book.getFigures();
    this.setState({ figures });
  }

  selectFigures(selectedFigures) {
    this.setState({ selectedFigures });
  }

  renderFigures() {
    let figures = this.state.selectedFigures.slice(0, this.state.loadCard);
    figures = this.state.sortOrder === "az" ? figures : figures.reverse();
    return figures.map((figure, index) => {
      return (
        <FigureCardContainer
          figure={figure}
          load={this.state.loadImage > index}
          onClick={() => this._enlargeFigure(index)}
          key={figure.figureId}
        />
      );
    });
  }

  _enlargeFigure(activeIndex) {
    this.setState({ activeIndex });
    Fraction.Reporter.gaEvent("reader/panel/figures/enlarge");
  }

  _loadMoreImages() {
    this.setState(prevState => ({ loadImage: prevState.loadImage + 25 }));
  }

  _loadMoreCards() {
    this.setState(prevState => ({ loadCard: prevState.loadCard + 250 }));
  }

  _scrollFigures() {
    const { loadCard, loadImage } = this.state;
    const cardFigure = this.state.selectedFigures[loadCard - 125];
    let figureId = cardFigure && cardFigure.figureId;
    let el = figureId && document.getElementById(`figure-${figureId}`);
    if (
      el &&
      (Fraction.Helpers.isScrolledIntoView(el) ||
        Fraction.Helpers.wasScrolledIntoView(el))
    ) {
      this._loadMoreCards();
    }
    const imageFigure = this.state.selectedFigures[loadImage - 25];
    figureId = imageFigure && imageFigure.figureId;
    el = figureId && document.getElementById(`figure-${figureId}`);
    if (
      el &&
      (Fraction.Helpers.isScrolledIntoView(el) ||
        Fraction.Helpers.wasScrolledIntoView(el))
    ) {
      this._loadMoreImages();
    }
  }

  _goToNextFigure() {
    const max = this.state.selectedFigures.length - 1;
    this.setState(prevState => {
      if (prevState.activeIndex === max) {
        return { activeIndex: 0 };
      } else {
        return { activeIndex: prevState.activeIndex + 1 };
      }
    });
  }

  _goToPreviousFigure() {
    this.setState(prevState => {
      if (prevState.activeIndex === 0) {
        return { activeIndex: prevState.selectedFigures.length - 1 };
      } else {
        return { activeIndex: prevState.activeIndex - 1 };
      }
    });
  }

  _closeFigure() {
    this.setState({ activeIndex: null });
  }

  onSort(order) {
    this.setState(prevState => {
      if (prevState.sortOrder !== order) {
        return { sortOrder: order };
      }
    });
  }

  _backToChapters() {
    this.setState({ selectedFigures: null });
  }

  render() {
    const { activeIndex, figures, selectedFigures, sortOrder } = this.state;
    let figureScreen = this.state.selectedFigures ? " selected" : "";
    if (activeIndex || activeIndex === 0) {
      return (
        <FiguresOverlay
          activeFigure={selectedFigures[activeIndex]}
          close={this._closeFigure}
          previous={this._goToPreviousFigure}
          next={this._goToNextFigure}
          isbn={this.props.isbn}
        />
      );
    } else if (!selectedFigures) {
      return (
        <Chapters
          enlargeFigure={this._enlargeFigure}
          figures={this.state.figures}
          isbn={this.props.isbn}
          onSelect={this.onSort}
          selectFigures={this.selectFigures}
          sortOrder={sortOrder}
        />
      );
    } else {
      return (
        <div id="figures-container" className="figures-panel">
          <PanelHeader
            headerClick={this._backToChapters}
            title={i18n.t("reader.panels.figures") || this.props.title}
            close={this._closeFiguresPanel}
          />
          <Header
            count={this.state.selectedFigures.length}
            sortOrder={sortOrder}
            onSelect={this.onSort}
          />
          <ul
            className={"figures-results" + figureScreen}
            onScroll={this._scrollFigures}
          >
            {this.renderFigures()}
          </ul>
        </div>
      );
    }
  }
}

const gadgetId = "figures";
module.exports = {
  class: FiguresContainer,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      learnMore: false,
      launch: "// TODO",
      toggle: false,
      expanded: false,
      hideHeader: true,
      type: "panel",
      autoShow: isbn => {
        const book = BookStore.get(isbn);
        return book.hasFigures;
      },
      enabled: () => Fraction.Brand.Sidebar.Buttons.figures,
      sidebar: {
        icon: "/img/figures/figures.svg",
        light: isbn => !BookStore.get(isbn).hasFigures,
        toolTip: isbn => {
          const book = BookStore.get(isbn);
          if (book.hasFigures) {
            return i18n.t(`reader.panels.${gadgetId}`);
          } else {
            return i18n.t("reader.figures.figures-unavailable");
          }
        },
        action: isbn => {
          const book = BookStore.get(isbn);
          if (book.hasFigures) {
            Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
          } else {
            Fraction.Helpers.toast(i18n.t("reader.figures.view-not-available"));
          }
        }
      }
    };
  }
};
